import { AccordionProps } from '@mui/material'
import React from 'react'
import StyledAccordionContainer from './StyledAccordionContainer'

type StyledAccordionProps = AccordionProps & {
  children: React.ReactNode
}

const StyledAccordion: React.FC<StyledAccordionProps> = ({ children, ...accordionProps }) => {
  return (
    <StyledAccordionContainer
      {...accordionProps}
      sx={(theme) => {
        const userSx = typeof accordionProps.sx === 'function'
          ? accordionProps.sx(theme)
          : accordionProps.sx || {};
        return {
          '& .MuiAccordionDetails-root': { pb: 0 },
          ...userSx as object,
        };
      }}
    >
      {children ?? <></>}
    </StyledAccordionContainer>
  )
}

export default StyledAccordion
